/** Bucket and vase items support diameter/depth (cm) — mirrors backend `ITEM_CATEGORY_CODES_WITH_VESSEL_DIMENSIONS`. */
export const VESSEL_ITEM_CATEGORY_CODES = ["BUCKET", "BUCKETS", "VASE", "VASES"] as const;

export function isVesselItemCategory(code: string): boolean {
  return (VESSEL_ITEM_CATEGORY_CODES as readonly string[]).includes(code);
}
